import React from 'react'
import Bg from '../../images/shapes/bg_pattern_4.svg'


const PageTitle = (props) => {
    const sectionStyle = props.bgOverride
        ? props.bgOverride
        : { backgroundImage: `url(${Bg})` };

    return (
        <section className="page_banner_section text-center" style={sectionStyle}>
            <div className="container">
                <div className={`heading_focus_text ${props.darkText ? 'text-dark' : 'text-white'}`}>
                    {props.pageTop}
                    <span className="badge bg-secondary">{props.pagesub}</span>
                </div>
                <h1 className={`page_title mb-0 ${props.darkText ? 'text-dark' : 'text-white'}`}>{props.pageTitle}</h1>
            </div>
        </section>
    )
}

export default PageTitle;